module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-goodsInfoPreview","title":"商品信息预览组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-goodsInfoPreview/package.json
// module id = 231
// module chunks = 1